import FaqPage from './FaqPage';

export default FaqPage;